import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-assay-workbook-export-renderer',
  templateUrl: './assay-workbook-export-renderer.component.html',
  styleUrl: './assay-workbook-export-renderer.component.scss'
})
export class AssayWorkbookExportRendererComponent {
  @Input() summaryTableId = 'assay-summary-export-table';
  @Input() detailsTableId = 'assay-details-export-table';
}
